import { TLCLogger } from "../../../../js/lib/logger";
import { TLCRest } from "../../../../js/lib/rest/REST";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { ApplicationData } from "../ApplicationData";
import { LS2PAC_Utils } from "../utils/Utils";
import { EResourcesAvailabilityClientManager } from "./EResourcesAvailabilityClientManager";

export const AvailabilityClientManager = (function( $ ) {

	var restUrl = LS2PAC_CONSTANTS.restUrls.availability,
		availabilityCache = {},
		upperLimit = 30,
		flushTime = 300000;

	var createAvailabilityCache = function( itemIdentifier, availability, currentTimestamp ) {
		if( availabilityCache["_" + itemIdentifier] === undefined ) {
			availabilityCache["_" + itemIdentifier] = {
				timestamp:    currentTimestamp,
				availability: availability
			};
		}
	};

	//TODO we should be able to hook this up to the window.localStorage api for even longer lasting results
	//TODO rewrite the to do above this so it doesn't sound like an enzyte commercial
	var updateFromCache = function( holdingsInformation, currentTimestamp ) {
		//we call availability WAY too much, lets cache it for 15 minutes...
		var tempAvailabilityCache = availabilityCache["_" + holdingsInformation.barcode];
		if( tempAvailabilityCache && (currentTimestamp - tempAvailabilityCache.timestamp) < flushTime ) {
			//TLCLogger.log(holdingsInformation.barcode + " read from cache", tempAvailabilityCache.availability)
			syncAvailabilityWithHolding( holdingsInformation, tempAvailabilityCache.availability );
		}
	};

	var syncAvailabilityWithHolding = function( holdingsInformation, itemAvailability ) {
		holdingsInformation.itemIdentifier = itemAvailability.itemIdentifier;
		holdingsInformation.available = itemAvailability.available;
		holdingsInformation.dueDate = itemAvailability.dueDate;
		if( holdingsInformation.dueDate ) {
			holdingsInformation.dueDateString = LS2PAC_Utils.getDateString( holdingsInformation.dueDate );
		}
		holdingsInformation.nonCirculating = itemAvailability.nonCirculating;
		holdingsInformation.onOrder = itemAvailability.onOrder;
		holdingsInformation.status = itemAvailability.status;
	};

	var getLocalHoldingsFirst = function( localHoldings, holdingsInformations, getEveryAvailability ) {
		var _currentBranch = ApplicationData.branchLimitsUtil.getCurrentBranchIfNotLimited();
		if( _currentBranch ) {
			//get all the holdings from the local branch
			localHoldings = $.grep( holdingsInformations, function( holdingsInformation ) {
				return holdingsInformation.branchIdentifier == _currentBranch;
			} );
			//TLCLogger.log("location based availability?", localHoldings.length, localHoldings);

			if( getEveryAvailability ) {
				var tempHoldings = $.grep( holdingsInformations, function( holdingsInformation ) {
					return holdingsInformation.branchIdentifier != _currentBranch;
				} );
				//TLCLogger.log("all other holdings?", tempHoldings.length, tempHoldings);
				localHoldings = localHoldings.concat( tempHoldings );
			}

			return localHoldings;
		} else {
			//TLCLogger.log("theres no current branch", holdingsInformations.length, holdingsInformations);
			return holdingsInformations;
		}
	};

	// private
	var getItemAvailability_util = function( holdingsInformations, callback, resources = [], callCanAbort = true, downloadableResources = [] ) {
		var callSuccess = false;
		var holdingsToSend = holdingsInformations;//.slice(0);
		var currentTimestamp = new Date().getTime();
		if( holdingsToSend.length > 0 ) {
			// Supports availability
			if( ApplicationData.supportedFunctionality.supportsAvailabilityFunctionality ) {
				var itemAvailabilities = [];
				$.each( holdingsToSend, function( index, holdingsInformation ) {
					if( holdingsInformation.barcode.length > 0 ) {
						itemAvailabilities.push( {
							itemIdentifier: holdingsInformation.barcode,
							resourceId:     holdingsInformation.resourceId
						} );
					}
				} );
				//TLCLogger.log("itemAvailabilities", itemAvailabilities.length);
				if( itemAvailabilities.length !== 0 ) {
					var myCallback = function( itemAvailabilityReturn ) {
						TLCLogger.log( "itemAvailabilityReturn:", itemAvailabilityReturn, holdingsToSend );
						try {
							$.each( itemAvailabilityReturn.itemAvailabilities, function( index, itemAvailability ) {
								$.each( holdingsToSend, function( index2, holdingsInformation ) {
									if( holdingsInformation.barcode == itemAvailability.itemIdentifier ) {
										syncAvailabilityWithHolding( holdingsInformation, itemAvailability );
										createAvailabilityCache( itemAvailability.itemIdentifier, itemAvailability, currentTimestamp );
									}
								} );
							} );
							callSuccess = true;
						} catch( badThings ) {
							TLCLogger.log( badThings );
						}
					};
					TLCRest.jsonCall( restUrl, {
						callback:       myCallback,
						finallyHandler: function() {
							if( downloadableResources.length > 0 ) {
								EResourcesAvailabilityClientManager.getDownloadableItemAvailability( {
									downloadableResources: downloadableResources,
									resources:             resources,
									callback:              callback,
									callCanAbort:          callCanAbort,
									wentToServer:          true,
									callSuccess:           callSuccess
								} );
							} else if( callback ) {
								callback( resources, true, callSuccess );
							}
						},
						timeout:        60000,
						postData:       itemAvailabilities,
						cancellable:    callCanAbort
					} );
				} else {
					if( downloadableResources.length > 0 ) {
						EResourcesAvailabilityClientManager.getDownloadableItemAvailability( {
							downloadableResources: downloadableResources,
							resources:             resources,
							callback:              callback,
							callCanAbort:          callCanAbort,
							wentToServer:          false,
							callSuccess:           callSuccess
						} );
					} else if( callback ) {
						callback( resources, false, callSuccess );
					}
				}
			} else {
				if( callback ) callback( resources, false, true );
			}
		} else {
			if( downloadableResources.length > 0 ) {
				EResourcesAvailabilityClientManager.getDownloadableItemAvailability( {
					downloadableResources: downloadableResources,
					resources:             resources,
					callback:              callback,
					callCanAbort:          callCanAbort,
					wentToServer:          false,
					callSuccess:           callSuccess
				} );
			} else if( callback ) {
				callback( resources, false, callSuccess );
			}
		}
	};

	return {
		clearCache:                    function() {
			availabilityCache = {};
		},
		getItemAvailabilityByHoldings: function( theHoldings, resourceId, /*Function*/ callback, refreshAvailability = false, /* func[optional]*/ callCanAbort = true ) {
			var needsToGoToServer = false,
				holdingsInformations = [],
				currentTimestamp = new Date().getTime();

			$.each( theHoldings, function( index2, holdingsInformation ) {
				updateFromCache( holdingsInformation, currentTimestamp );
				if( (holdingsInformation.available === undefined || refreshAvailability === true) && holdingsInformation.hideFromPublic === false ) {
					needsToGoToServer = true;
					holdingsInformation.resourceId = resourceId;
					holdingsInformations.push( holdingsInformation );
					createAvailabilityCache( resourceId, currentTimestamp );
				}
			} );

			if( needsToGoToServer === false ) {
				TLCLogger.log( "AvailabilityDataModel.getItemAvailabilityByHoldings - i already have it, just return" );
				if( callback ) {
					callback( theHoldings, false, true );
				}
				return;
			}
			getItemAvailability_util( holdingsInformations, callback, undefined, callCanAbort );
		},
		/**
		 * Gets the availability of a list of resources
		 * TODO tlc.ls2pac.model.Resource is resources
		 * @param {Array.<Object>} resources
		 * @param {function(Object)=} callback the callback to fire with the results
		 * @param {boolean=} refreshAvailability whether or not to force refreshing the availability, defaults to false
		 * @param {boolean=} callCanAbort whether or not this call can be aborted, defaults to true
		 * @param {boolean=} getEveryAvailability whether or not to get every location, defaults to false
		 */
		getItemAvailability:           function( resources, callback, refreshAvailability = false, callCanAbort = true, getEveryAvailability = false ) {
			var needsToGoToServer = false,
				totalHoldingsInformations = [],
				resourceHoldings = [],
				currentTimestamp = new Date().getTime();

			$.each( resources, function( index, resource ) {
				resourceHoldings = [];

				if( parseInt( resource.rtype, 10 ) === 1 ) {
					var checkForTooMany = (ApplicationData.getBranchToUseForAvailability() == null && getEveryAvailability != true);
					resource.tooManyholdingsToFetch = false;
					$.each( getLocalHoldingsFirst( [
					], resource.holdingsInformations, getEveryAvailability ), function( index2, holdingsInformation ) {
						updateFromCache( holdingsInformation, currentTimestamp );
						if( typeof holdingsInformation.available == 'undefined' || refreshAvailability === true ) {
							needsToGoToServer = true;
							holdingsInformation.resourceId = resource.id;
							resourceHoldings.push( holdingsInformation );
						}
						/*
						 if we DON'T have a local branch
						 AND we Don't want every availability
						 AND the holdings count is over our upper thresh hold
						 */
						if( checkForTooMany && resourceHoldings.length > upperLimit ) {
							resource.tooManyholdingsToFetch = true;
							return false;
						}
					} );
					totalHoldingsInformations = totalHoldingsInformations.concat( resourceHoldings );
				}
			} );

			// This is in the case where there all the results are electronic resources
			var downloadableResources = $.grep( resources, function( resource, index ) {
				return (resource.downloadable);
			} );


			if( needsToGoToServer === false ) {
				if( downloadableResources.length > 0 ) {
					EResourcesAvailabilityClientManager.getDownloadableItemAvailability( {
						downloadableResources: downloadableResources,
						resources:             resources,
						callback:              callback,
						callCanAbort:          callCanAbort,
						wentToServer:          false,
						callSuccess:           false
					} );
					return;
				}
				TLCLogger.log( "didn't go to the server" );
				if( callback ) {
					callback( resources, needsToGoToServer, true );
				}
				return;
			}

			getItemAvailability_util( totalHoldingsInformations, callback, resources, callCanAbort, downloadableResources );
		}
	};


})( jQuery );
